//--------------- IMPORTAÇÕES ---------------//
import { createContext, useState } from "react";



//--------------- CRIAÇÃO DO CONTEXTO DE TAGS ---------------//
export const TrackingContext = createContext();



//--------------- EXPORTAÇÃO DO PROVIDER DO CONTEXTO DE TAGS ---------------//
export const TrackingProvider = ({ children }) => {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const [startDateFilter, setStartDateFilter] = useState(null); // Estado que armazena a Data informada pelo usuário no filtro 
    const [endDateFilter, setEndDateFilter] = useState(null); // Estado que armazena a Data informada pelo usuário no filtro
    const [urlFilter, setUrlFilter] = useState("");
    const [productFilter, setProductFilter] = useState("");
    const [campaignFilter, setCampaignFilter] = useState("");
    const [sourceFilter, setSourceFilter] = useState("");
    const [events, setEvents] = useState([]); // Estado que armazena a lista de eventos existentes
    const [groupProducts, setGroupProducts] = useState([]); // Estado que armazena a lista de grupos de produtos existentes
    const [groupProductsFilter, setGroupProductsFilter] = useState(null); // Estado que armazena o grupo de produtos selecionado pelo usuário no filtro


    const [isOpenModalEventsTracking, setIsOpenModalEventsTracking] = useState(false); //  Estado que armazena se o Modal Evento do Tracking está aberto ou não
    const [isLoadingModalEventTracking, setIsLoadingModalEventTracking] = useState(false);
    const [formDataModalEventTracking, setFormDataModalEventTracking] = useState({}); // Estado que armazena o ID do Visitor Selecionado pelo usuário



    //--------------- RETORNO DO PROVIDER ---------------//
    return (
        <TrackingContext.Provider value={{
            startDateFilter, setStartDateFilter, events, setEvents, isOpenModalEventsTracking, setIsOpenModalEventsTracking,
            isLoadingModalEventTracking, setIsLoadingModalEventTracking, formDataModalEventTracking, setFormDataModalEventTracking,
            endDateFilter, setEndDateFilter, urlFilter, setUrlFilter, productFilter, setProductFilter, campaignFilter, setCampaignFilter,
            sourceFilter, setSourceFilter, groupProducts, setGroupProducts, groupProductsFilter, setGroupProductsFilter
        }}>
            {children}
        </TrackingContext.Provider>
    );



};